import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { FiCalendar, FiMapPin, FiClock } from "react-icons/fi";


function EventCard({ club, collaborating_clubs, description, event_date, organizing_club, poster_image, registration_deadline, registration_link, title, venue, concluded }) {

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    var date1 = new Date();
    var date2 = new Date(registration_deadline);
    var date3 = new Date(event_date);
    var diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10);

    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    const displayDate = date3.toLocaleDateString("en-US", options)


    return (
        <div className='eventCard' data-aos="fade-up">
            <div className='event_img'>
                <img src={poster_image} alt='' onClick={handleClickOpen} />
            </div>
            <Dialog open={open} onClose={handleClose}>
                <DialogContent>
                    <div className='eventCard_img_modal'>
                        <img src={poster_image} alt='' />
                    </div>
                    <div className='eventCard_img_desc'>
                        <p className='about__p'>{description}</p>
                    </div>
                </DialogContent>
            </Dialog>
            <div className='event_details'>
                <div className='event_title'>
                    <h1>{title}</h1>
                    {/* <FiShare2 className='share_icon'/> */}
                </div>
                <h3>{organizing_club}</h3>
                <div className='event_info'>
                    <div className='event__content'>
                        <FiCalendar className='event_info_icon' />
                        <h3>{displayDate}</h3>
                    </div>
                    <div className='event__content'>
                        <FiMapPin className='event_info_icon' />
                        <h3>{venue}</h3>
                    </div>
                </div>
                <div className='event_info'>
                    <div className='event__content'>
                        {concluded ? <><h3>Event Concluded</h3>
                        </> :
                            registration_deadline ? (
                                <>
                                    <FiClock className='event_info_icon' />
                                    {diffDays < 0 ? <h3>Registration Closed</h3> : <h3>{diffDays} days left to register</h3>}
                                </>
                            ) : <>
                                <>
                                    <FiClock className='event_info_icon' />
                                    <h3>No registration deadline</h3>
                                </>
                            </>}
                    </div>
                    <div className='event__content'>
                        {/* <button className='event_btn det_btn'>Details</button> */}
                        <button className='event_btn reg_btn' disabled={concluded ? true : false} >
                            {!concluded ? (
                                <a href={registration_link} target='_blank' rel="noreferrer">Register</a>
                            ) : <span>Register</span>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventCard